import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getEquipmentsById } from "components/axios/equipmentAxios";
import EquipmentForm from "components/inner/equipment/Form";
import EquipmentSpec from "components/inner/equipment/Spec";
import { useState } from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import EquipmentGateway from "components/inner/equipment/Gateways";
import EquipmentSensor from "components/inner/equipment/Sensors";
import EquipmentStatus from "components/inner/equipment/Status";
import { getGatewaysByQuery } from "components/axios/iotAxios";
import FormSubList from "components/inner/equipment/FormSubList";

const EquipmentModifySetting = () => {
    const { t } = useTranslation();
    const {id} = useParams();
    const [info, setInfo] = useState(null);
    let [paramId, setParamId] = useState(id);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!isLoading) {
            equipmentInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[id, paramId, isLoading]);

    const equipmentInfo = (eId) => {
        if (id || eId) {
            paramId = (id || eId);
            setParamId(paramId);
            getEquipmentsById(paramId).then((res)=>{
                setInfo(res);
                setIsLoading(true);
            })
        } else {
            setIsLoading(true);
        }
    }

    useEffect(() => {
        equipmentGatewayList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramId])

    // useEffect(() => {
    //     if (info) {
    //         equipmentPartAllList();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [info])

    const [equipmentGateways, setEquipmentGateways] = useState(null);
    const equipmentGatewayList = ()=> {
        if (paramId) {
            getGatewaysByQuery({"equipments.equipment.id":paramId, size:400}).then((res2)=>{
                if (res2 && res2._embedded) {
                    setEquipmentGateways(res2._embedded.gatewayDTOes);
                } else {
                    setEquipmentGateways(null);
                }
            })
        }
    }

    // const [equipmentParts, setEquipmentParts] = useState(null);
    // // 설비에 등록된 자재목록
    // const equipmentPartAllList = async()=> {
    //     if (info) {
    //         const param = { "equipment.id": info.id, deletedYn:false, size:100};
    //         await getEquipmentPartsByQuery(param).then((data) => {
    //             if (data && data._embedded) {
    //                 const list = data._embedded.equipmentParts;
    //                 if (list) {
    //                     setEquipmentParts(list);
    //                 } else {
    //                     setEquipmentParts(null);
    //                 }
    //             } else {
    //                 setEquipmentParts(null);
    //             }
    //         });
    //     }
    // }
    const [equipmentNoList, setEquipmentNoList] = useState(null);

    if (isLoading) {
        return (
            <div className="cal">
                <div className="scroll_table">
                    <Row style={{width:"100%"}}>
                        <Col sm={8} className="main_left">
                
                            <EquipmentForm info={info} setIsLoading={setIsLoading} setEquipmentNoList={setEquipmentNoList} />

                            {/* <EquipmentSpec info={info}  equipmentPartAllList={equipmentPartAllList} /> */}
                            <EquipmentSpec info={info} />

                            <EquipmentGateway info={info} equipmentGateways={equipmentGateways} setIsLoading={setIsLoading} refreshGateways={equipmentGatewayList}  />

                            <EquipmentSensor info={info} />

                        </Col>

                        <Col sm={4} className="main_right">
                            {equipmentNoList && <FormSubList equipmentNoList={equipmentNoList}/>}
                            <EquipmentStatus info={info} />
                            
                        </Col>

                        <div style={{marginTop:"10px"}}>
                            <Link to={'/setting/basic/equipment'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}
export default EquipmentModifySetting;